import styled from '@emotion/styled'

export const Container = styled.div<{
  theme: string
  isDark: boolean
  inSiderbar: boolean
}>`
  margin-right: 0.5rem;

  @media (max-width: 768px) {
    display: ${(props) => (props.inSiderbar ? 'initial' : 'none')};
  }

  .ant-switch {
    height: 38px;
    border-radius: 10px;
    min-width: ${(props) => (props.inSiderbar ? '150px' : '70px')};
    background-color: ${(props) => (props.isDark ? '#133E5B' : '#fff')};
  }

  .ant-switch-checked .ant-switch-handle {
    left: ${(props) =>
      props.inSiderbar ? 'calc(100% - 30px - 2px)' : 'calc(100% - 30px - 2px)'};
  }

  .ant-switch-handle {
    width: ${(props) => (props.inSiderbar ? '100px' : '30px')};
    height: 38px;
    width: 38px;
    top: 0;
    left: 0;
  }

  .ant-switch-handle::before {
    background-image: url(${(props) => props.theme});
    background-color: #0f68aa;
    background-size: 19px 19px;
    background-repeat: no-repeat;
    background-position: 50% 50%;
    border-radius: 10px;
  }

  .ant-switch-checked .ant-switch-inner {
    margin: ${(props) =>
      props.inSiderbar ? '-4px 100px 0 0' : '-4px 30px 0 0'};
    height: 38px;
    width: 35px;
    line-height: 38px;
  }

  .ant-switch-checked:focus {
    box-shadow: none;
  }
  .ant-switch-inner {
    margin: ${(props) =>
      props.inSiderbar ? '-2px 0 0 100px' : '-2px 0 0 35px'};
  }
  .ant-switch:focus {
    box-shadow: none;
  }
`
